import { useEffect, useRef } from "react";

import { useRouter } from "next/router";
import { pageView } from "lib/gtm";
import useUser from "hooks/useUser";

export default function GTMPageViewTag() {
  const { asPath } = useRouter();
  const [user] = useUser();
  const currentPath = useRef(null);

  useEffect(() => {
    if (user.loading) {
      return;
    }

    if (currentPath.current !== asPath) {
      pageView(asPath, user.isAuthenticated ? user : undefined);
      currentPath.current = asPath;
    }
  }, [asPath, user]);

  return null;
}
